module.exports = __webpack_public_path__ + "images/patterns/light/BrickVertical.ce7658e1e8df2de54d00.svg";